// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `MenuDivider` is a part of [Menu](#!/Menu) component.
 * @since 0.0.57
 */
const MenuDivider = _ref => {
  let {
    className,
    baseClassName = `${CLS_PREFIX}menu__divider`,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: classNames(baseClassName, className),
    role: "separator",
    ...props
  });
};
export default MenuDivider;